module.exports = __webpack_public_path__ + "static/img/post_default_cover.7c166975.png";